import { useAuth } from "@/components/auth/auth-context";
import {
  Popover,
  PopoverContent,
  PopoverPortal,
  PopoverTrigger,
} from "@/components/ui/popover";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { Cog6ToothIcon, QuestionMarkCircleIcon } from "@heroicons/react/24/outline";
import { useRouter } from "@tanstack/react-router";
import { Loader2, LogOut } from "lucide-react";
import { useState } from "react";

export function WizardChrome() {
  const { revokeSession } = useAuth();
  const router = useRouter();
  const [pendingLogout, setPendingLogout] = useState(false);

  const handleLogout = async () => {
    setPendingLogout(true);
    try {
      await revokeSession();
      router.navigate({ to: "/login" });
    } finally {
      setPendingLogout(false);
    }
  };

  return (
    <div className="pointer-events-none absolute bottom-6 left-6 z-20 flex items-center gap-3">
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <button
              type="button"
              onClick={() => window.Intercom?.("show")}
              className="pointer-events-auto text-text-secondary transition-colors hover:text-text-primary"
              aria-label="Help and support"
            >
              <QuestionMarkCircleIcon className="size-6" />
            </button>
          </TooltipTrigger>
          <TooltipContent side="top">
            <p>Help & Support</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>

      <Popover>
        <PopoverTrigger asChild>
          <button
            type="button"
            className="pointer-events-auto text-text-secondary transition-colors hover:text-text-primary"
            aria-label="Account menu"
          >
            <Cog6ToothIcon className="size-6" />
          </button>
        </PopoverTrigger>
        <PopoverPortal>
          <PopoverContent
            align="start"
            side="top"
            className="z-[60] w-[180px] p-0"
          >
            <button
              type="button"
              onClick={() => void handleLogout()}
              disabled={pendingLogout}
              className="flex w-full flex-row items-center gap-2 px-4 py-2.5 text-left hover:bg-surfaces-z2 disabled:opacity-60"
            >
              {pendingLogout ? (
                <Loader2 className="size-4 animate-spin text-states-error" />
              ) : (
                <LogOut className="size-4 text-states-error" />
              )}
              <span className="font-body text-sm text-states-error">Logout</span>
            </button>
          </PopoverContent>
        </PopoverPortal>
      </Popover>
    </div>
  );
}
